import styled from 'styled-components'

export const FiltersPopoverContentStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: ${(props) => props.theme.typography.pxToRem(16)};
`
